import { Component, OnInit } from '@angular/core';
import { ProyectoService } from 'src/app/services/proyecto.service';
import { Productos } from 'src/app/models/producto.model';

@Component({
  selector: 'app-tienda-online',
  templateUrl: './store-online.component.html',
  styleUrls: ['./store-online.component.scss']
})
export class TiendaOnlineComponent implements OnInit {

  productos: Productos[] = [];
  imagenes: string[] = [
    'Boligrafo giratorio.png',
    'Libreta bordada.png',
    'Bolsa de algodon.png',
    'Gorra bordada.png',
    'Chaleco bordado.png',
    'Termo 500 ml.png',
    'Casco de seguridad.png',
    'Carpete Congress.jpg',
    'Taza.jpg'
  ];

  constructor(private productService: ProyectoService) { }

  ngOnInit(): void {
    this.productService.getAllProducts().subscribe(
      response => {
        if (response.success) {
          this.productos = response.data.filter(producto => producto.tipo === 'Tienda en línea'); 
        } else {
          console.error('Error en la respuestas:', response.messages);
        }
      },
      error => {
        console.error('Error al obtener productos:', error);
      }
    );
  }

  getImageFileName(index: number): string {
    return this.imagenes[index % this.imagenes.length];
  }

}
